import { Block, Typography } from '@aloft/toolkit-sui';

export const TwoLineCell = ({ line1, line2 }: { line1: string; line2: string }) => (
  <Block>
    <Typography>{line1}</Typography>
    <Typography>{line2}</Typography>
  </Block>
);
